export default __webpack_public_path__ + "static/values-pursue-excellence-f37f966264ff88bcdc9ec55bab94afba.svg";